import React, { useState, useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import css from './Dropdown.module.scss'

export default function Dropdown ({open = false, dataTarget = '', header, className, activeClassName, align, children}) {
	const [isOpen, setOpen] = useState(open)
	const ref = React.useRef(null)

	const onDocumentMouseDown = (e) => {
		if (!ref.current.contains(e.target)) {
			listeners(false)
			setOpen(false)
		}
	}

	const listeners = (active = true) => {
		if (active) {
			document.addEventListener('mousedown', onDocumentMouseDown, true)
			document.addEventListener('click', onDocumentMouseDown)
		} else{
			document.removeEventListener('mousedown', onDocumentMouseDown, true)
			document.removeEventListener('click', onDocumentMouseDown)
		}
	}

	const toogle = () => {
		listeners(!isOpen)
		setOpen(!isOpen)
		setTimeout(() => {
			ReactTooltip.rebuild()
		}, 0)
	}

	useEffect(() => {
		return () => {
			listeners(false)
		}
	},[]);

	useEffect(() => {
		setOpen(open)
	},[open]);

    return (
        <div className={css.dropdown + ' ' + (className || '') + ' ' +(isOpen ? activeClassName || '' : '') + ' ' + (css[align] || '')} ref={ref}>
			<div className={css.header} onClick={toogle} >
				{header}
			</div>
	        {isOpen
		        ? <div className={css.body} data-target={dataTarget}>
			        {children}
		        </div>
		        : null
	        }
        </div>
    );
}